/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-return-assign */
import TextFilter from 'components/atoms/text_filter';
import React, { useEffect, useRef, useState } from 'react';
import DataTable from 'react-data-table-component';
import EditorViewModal from 'components/molecules/editor_view_modal';
import { DocumentState, DrLicitaState } from 'store/modules/dr_licita_store/types';
import { ApplicationState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { destroyDocument, getDocuments } from 'store/modules/dr_licita_store/actions';
import { getPanelProperties } from 'store/modules/panel_store/actions';
import Loader from 'components/atoms/loader';
import tabId from 'services/tabId';
import { SaleDrLicita } from 'pages/SaleDrLicita';
import Onboarding from 'components/molecules/onboarding';
import { hasCookie } from 'services/actions/cookies_actions';
import DrLicitaTutorial from 'components/organisms/dr_licita_tutorial';
import OpenTutorial from 'components/atoms/open_tutorial';
import { ProfileState } from 'store/modules/profile_store/types';
import { PanelState } from 'store/modules/panel_store/types';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import { track } from 'services/tracking';
import { datatableColumns, datatableData } from './datatable_list';
import { ContainerTable } from './styles';

const DrLicita = () => {
  const { documents, documents_request } = useSelector<ApplicationState, DrLicitaState>(
    (state) => state.session.dr_licita,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel, request: panelRequest } = useSelector<ApplicationState, PanelState>(
    (state) => state.session.panel,
  );

  const [modalEditorOpened, setModalEditorOpened] = useState<boolean>(false);
  const [filterValue, setFilterValue] = useState<string>('');
  const [filteredList, setFilteredList] = useState<Array<DocumentState>>(documents);
  const [selectedDocumentID, setSelectedDocumentID] = useState<number>(0);

  const dispatch = useDispatch();

  const deleteDocument = (document_id: number) => {
    dispatch(destroyDocument(document_id));
  };

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '15px',
        paddingRight: '15px',
      },
    },
    cells: {
      style: {
        paddingLeft: '15px',
        paddingRight: '15px',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
      },
    },
  };

  useEffect(() => {
    document.title = 'Dr Licita - ConLicitação';
    dispatch(getDocuments());
  }, []);

  // Deep-link do chat (Dr. Licita v3): /dr_licita?document=<id> já abre a
  // peça — somente depois da lista carregar (o modal lê o documento dela)
  const deepLinkHandled = useRef(false);
  useEffect(() => {
    if (deepLinkHandled.current || !documents_request.loaded) return;
    const documentId = Number(new URLSearchParams(window.location.search).get('document'));
    if (documentId > 0 && documents.some((item) => item.id === documentId)) {
      deepLinkHandled.current = true;
      setSelectedDocumentID(documentId);
      setModalEditorOpened(true);
    }
  }, [documents_request.loaded, documents]);

  useEffect(() => {
    if (!panelRequest?.loaded && !panelRequest?.loading) {
      dispatch(
        getPanelProperties(profile?.representant ? profile?.currentCompany[tabId()] : undefined),
      );
    }
  }, [dispatch, panelRequest?.loaded, panelRequest?.loading, profile]);

  useEffect(() => {
    const list =
      documents.filter(
        (document) =>
          document.id.toString().toLowerCase().includes(filterValue.toLowerCase()) ||
          document.title.toLowerCase().includes(filterValue.toLowerCase()),
      ) || [];

    return setFilteredList(list);
  }, [filterValue, documents]);

  // sem o serviço = sinal de intenção; fica em effect com guard (não no corpo do
  // render) para disparar UMA vez, mesmo com re-renders enquanto o redirect carrega
  const triedDrLicitaRef = useRef(false);
  const blockedDrLicita =
    !!panelRequest?.loaded && !!profile?.validate_services && !profile.can_use_dr_licita;
  useEffect(() => {
    if (blockedDrLicita && !triedDrLicitaRef.current) {
      triedDrLicitaRef.current = true;
      track('intencao.tentou_dr_licita');
      window.location.href = '/contato';
    }
  }, [blockedDrLicita]);

  if (!panelRequest?.loaded || !profile?.validate_services) {
    return <Loader />;
  }

  if (!profile.can_use_dr_licita) {
    return <Loader />;
  }

  const panelValue = panel?.validate_services?.dr_licita;
  const profileValue = profile?.validate_services?.dr_licita;
  const hasAccess = panelValue !== undefined ? panelValue : !!profileValue;

  if (!hasAccess && panel?.prize?.name !== 'Dr. Licita') {
    return <SaleDrLicita />;
  }

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions">
        <div className="row mb-4 px-md-4 py-4">
          <div className="col-md-12 mb-3">
            <div className="d-md-flex d-block align-items-center">
              <h4 className="mb-1 mr-3">Dr Licita - Petições inteligentes</h4>
              <OpenTutorial type="container" source="drlicita" />
            </div>
          </div>
          {panel?.services_paralyzed?.dr_licita ? (
            <BlockedSubscription paralyzed />
          ) : (
            <ContainerTable className="col-12">
              <div className="card p-4">
                {filteredList.length === 0 ? (
                  filterValue.trim() === '' ? (
                    <div>
                      <div className="py-3">Você e a sua equipe não possuem teses ainda.</div>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary mx-0 d-flex align-items-center tour-begin-dr-licita"
                        onClick={() => (window.location.href = '/dr_licita/document')}
                      >
                        <span className="d-flex align-items-center">
                          Criar sua primeira petição
                          <i className="material-icons ml-1">arrow_forward</i>
                        </span>
                      </button>
                    </div>
                  ) : (
                    <div>
                      <div className="col-12 mb-3 d-md-flex justify-content-between align-items-center px-0">
                        <TextFilter
                          textFilterValue={filterValue}
                          setTextFilterValue={setFilterValue}
                          placeHolder="Buscar"
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-primary ml-md-2 ml-0 d-flex align-items-center"
                          onClick={() => (window.location.href = '/dr_licita/document')}
                        >
                          <i className="material-icons mr-1">add</i>
                          Criar nova petição
                        </button>
                      </div>

                      <div className="p-3">Nenhuma petição encontrada para a busca.</div>
                    </div>
                  )
                ) : (
                  <div>
                    <div className="col-12 mb-3 d-md-flex justify-content-between align-items-center px-0">
                      <TextFilter
                        textFilterValue={filterValue}
                        setTextFilterValue={setFilterValue}
                        placeHolder="Buscar"
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-primary ml-md-2 ml-0 d-flex align-items-center"
                        onClick={() => (window.location.href = '/dr_licita/document')}
                      >
                        <i className="material-icons mr-1">add</i>
                        Criar nova petição
                      </button>
                    </div>

                    {documents_request.loading && <Loader />}

                    {documents_request.loaded && (
                      <DataTable
                        columns={datatableColumns(
                          setModalEditorOpened,
                          deleteDocument,
                          setSelectedDocumentID,
                        )}
                        customStyles={customStyles}
                        data={datatableData(filteredList)}
                        noDataComponent={
                          <div className="p-5">Nenhuma petição encontrada para a busca.</div>
                        }
                      />
                    )}
                  </div>
                )}
              </div>

              {documents_request.loaded && filteredList.length === 0 && filterValue.trim() === '' && (
                <>
                  <h4 className="mt-5 mb-2">Entenda como usar a ferramenta:</h4>
                  <DrLicitaTutorial />
                </>
              )}
            </ContainerTable>
          )}
        </div>
      </div>
      <EditorViewModal
        modalEditorOpened={modalEditorOpened}
        setModalEditorOpened={setModalEditorOpened}
        documentTemplate={documents.find((document) => document.id === selectedDocumentID)}
      />
      {filteredList.length === 0 && !hasCookie('tourBeginDrLicita') && (
        <Onboarding tourSelect="tourBeginDrLicita" />
      )}
    </div>
  );
};
export default DrLicita;
